import { GameState, PerformActionRequest, PerformMoveRequest } from "@shared/types";
import { getJsonApi, postJsonApi } from "../helpers";

export async function getState(): Promise<GameState> {
    return getJsonApi<GameState>("state");
}

export async function performAction(
    actionAlias: string,
    objectAliases?: string[]
): Promise<GameState | undefined> {
    try {
        return postJsonApi<GameState, PerformActionRequest>("action", {
            action: actionAlias,
            objects: objectAliases,
        });
    } catch {
        return undefined;
    }
}

export async function performMove(moveAlias: string, objectAliases?: string[]): Promise<GameState> {
    const health: number = Number(localStorage.getItem("health")) - 15;
    localStorage.setItem("health", health.toString());
    if (health <= 0) {
        localStorage.removeItem("health");
    }
    return await postJsonApi<GameState, PerformMoveRequest>("move", {
        move: moveAlias,
        objects: objectAliases,
        health: health,
    });
}
